import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import type { ITrainingReportParameter } from "types/trainingReportTypes"

type Props = {
  parameters: Array<ITrainingReportParameter>
}

export function TrainingReportParameterList({ parameters }: Props) {
  return (
    <TableContainer>
      <Table size="medium">
        <TableHead>
          <TableRow>
            <TableCell align="left">Parameter</TableCell>
            <TableCell align="right">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {parameters.map((parameter) => (
            <TableRow
              key={parameter.id}
              hover
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell align="left">{parameter.name}</TableCell>
              <TableCell align="right">{parameter.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
